import { render, staticRenderFns } from "./esta_covid.vue?vue&type=template&id=e83c1c22"
import script from "./esta_covid.vue?vue&type=script&lang=js"
export * from "./esta_covid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports